<template>
  <div :class="[`view-465-1`, className || ``]">
    <div class="rectangle-203-4"></div>
    <div class="text-4-1 poppins-bold-black-20px">Недоступно</div>
  </div>
</template>

<script>
export default {
  name: "View472",
  props: ["className"],
};
</script>

<style>
.view-465-1 {
  align-self: center;
  height: 40px;
  position: relative;
  width: 152px;
}

.rectangle-203-4 {
  background-color: var(--black-6);
  border-radius: 10px;
  height: 40px;
  left: 0;
  position: absolute;
  top: calc(50% - 20px);
  width: 150px;
}

.text-4-1 {
  left: 12px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 5px;
}

.view-465-1.view-471,
.view-465-1.view-473,
.view-465-1.view-475,
.view-465-1.view-477 {
  align-self: center;
  height: 40px;
  margin-left: 71px;
  position: relative;
  width: 152px;
}

.view-465-1.view-471 .text-4-1,
.view-465-1.view-473 .text-4-1,
.view-465-1.view-475 .text-4-1,
.view-465-1.view-477 .text-4-1,
.view-465-1.view-472 .text-4-1,
.view-465-1.view-474 .text-4-1,
.view-465-1.view-476 .text-4-1,
.view-465-1.view-478 .text-4-1 {
  left: 13px;
}

.view-465-1.view-472,
.view-465-1.view-474,
.view-465-1.view-476,
.view-465-1.view-478 {
  align-self: center;
  height: 40px;
  margin-left: 76px;
  position: relative;
  width: 152px;
}
</style>
